import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components/macro'

import { media } from 'utilities/styled'

const Container = styled.div`
  display: flex;
  flex-direction: ${({ $inline }) => ($inline ? 'row' : 'column')};
  align-items: ${({ $inline }) => ($inline ? 'baseline' : 'stretch')};
  gap: ${({ theme, $inline }) =>
    $inline ? theme.sizeByFactor(0.5) : theme.sizeByFactor(0.625)};
  min-width: 0;
  font-family: ${({ theme }) => theme.font};
  color: ${({ theme }) => theme.colors.text};
`

const BrandAndModel = styled.span`
  display: flex;
  flex: 0 1 auto;
  gap: ${({ theme }) => theme.sizeByFactor(0.5)};
  min-width: 0;
  font-size: ${({ theme }) => theme.baseFontSize};
  font-weight: 600;
  line-height: ${({ theme }) => theme.baseFontSize};
  text-transform: uppercase;

  ${media.tablet`
    font-size: ${({ theme }) => theme.sizeByFactor(2)};
    line-height: ${({ theme, $inline }) =>
      $inline ? theme.sizeByFactor(2) : theme.baseFontSize};
  `}
`

const Brand = styled.span`
  flex-shrink: 0;
  white-space: nowrap;
`

const Model = styled.span`
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

const Type = styled.span`
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: ${({ theme }) => theme.baseFontSize};
  font-weight: ${({ theme }) => theme.baseFontWeight};
  line-height: ${({ theme }) => theme.baseFontSize};
  ${({ $inline }) => $inline && 'flex: 1 1 0;'}
`

/**
 * Title of a car file card: the brand and model as one bold line, with the
 * type (trim/edition) below it, or on the same line when `inline` is set.
 * Both lines are truncated with an ellipsis when they don't fit.
 */
const CarFileCardTitle = ({
  brand,
  model,
  type,
  inline,
  className,
  ...restProps
}) => (
  <Container
    className={className}
    $inline={inline}
    data-test-e2e="car-brand-and-model"
    {...restProps}
  >
    <BrandAndModel $inline={inline}>
      {brand && <Brand data-test-e2e="brand">{brand}</Brand>}
      {model && <Model data-test-e2e="model">{model}</Model>}
    </BrandAndModel>
    {type && (
      <Type $inline={inline} data-test-e2e="type">
        {type}
      </Type>
    )}
  </Container>
)

CarFileCardTitle.propTypes = {
  brand: PropTypes.string,
  model: PropTypes.string,
  type: PropTypes.string,
  /** Render the type on the same line as the brand and model (list view) */
  inline: PropTypes.bool,
  className: PropTypes.string,
}

CarFileCardTitle.defaultProps = {
  brand: null,
  model: null,
  type: null,
  inline: false,
  className: null,
}

export default CarFileCardTitle
